import { render, staticRenderFns } from "./faqiList.vue?vue&type=template&id=2a16733a&scoped=true&"
import script from "./faqiList.vue?vue&type=script&lang=js&"
export * from "./faqiList.vue?vue&type=script&lang=js&"
import style0 from "./faqiList.vue?vue&type=style&index=0&id=2a16733a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16733a",
  null
  
)

export default component.exports